import { pollTasks, reloadItems } from './reloadItems';
import { Datapoints } from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics';
import { logUsage } from 'owa-analytics';
import { setSelectedFolderId } from '../actions/todoPanelStoreActions';

/**
 * Note about starting polling for task updates:
 * We start polls either when the panel opened or when folder is switched.
 * We do not start polls after preloading because we don't want to keep fetching if the panel isn't going to be opened.
 * When the panel is closed, we stop polling.
 */
export async function switchFolderAsync(folderId: string) {
    const datapoint = new PerformanceDatapoint(
        Datapoints.todoPerformanceFolderSwitch.name,
        Datapoints.todoPerformanceFolderSwitch.options
    );

    // Setup polling to keep data updated.
    // Do this first (before waiting on reloadItems) because pollTasks in addition to setting up a new poll
    // also removes any previous polls.
    // Otherwise there's a small window in which previous timer may fire while we are reloading items for a new folder.
    pollTasks();

    setSelectedFolderId(folderId);
    await reloadItems(datapoint);

    logUsage(
        Datapoints.todoMetaDataTasks.name,
        Datapoints.todoMetaDataTasks.customData(),
        Datapoints.todoMetaDataTasks.options
    );
    datapoint.end();
}
